// extracted by mini-css-extract-plugin
export default {"recos":"R4-z","productCardOverride":"S4-z","rowHasBadge":"T4-z"};